module.exports = __webpack_public_path__ + "img/36.5df95480.jpg";